import { render, staticRenderFns } from "./MediaPlatformWithdraw.vue?vue&type=template&id=4f7f4f12&scoped=true&"
import script from "./MediaPlatformWithdraw.vue?vue&type=script&lang=js&"
export * from "./MediaPlatformWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./MediaPlatformWithdraw.vue?vue&type=style&index=0&id=4f7f4f12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f4f12",
  null
  
)

export default component.exports